import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Layout from './views/Layout.vue'
import Login from './views/Auth/Login.vue'
import auth from './middlewares/auth'
import OccurrenceDetail from './views/Occurrences/OccurrenceDetail.vue'
import OccurrenceList from './views/Occurrences/OccurrenceList.vue'
import SearchTransactions from './views/SearchTransactions/SearchTransactions.vue'
import SellerDetail from './views/Sellers/SellerDetail.vue'
import SellerList from './views/Sellers/SellerList.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '/',
          name: 'home',
          component: Home,
          meta: {
            middleware: auth
          }
        },
        {
          path: '/',
          name: 'seller-contract',
          component: Home,
          meta: {
            middleware: auth
          }
        },
        {
          path: '/cadastros',
          name: 'sellers',
          component: SellerList,
          meta: {
            middleware: auth
          }
        },
        {
          path: '/cadastros/:id',
          name: 'sellers-detail',
          component: SellerDetail,
          meta: {
            middleware: auth
          }
        },
        {
          path: '/ocorrencias',
          name: 'occurrences',
          component: OccurrenceList,
          meta: {
            middleware: auth
          }
        },
        {
          path: '/ocorrencias/:id',
          name: 'occurrences-detail',
          component: OccurrenceDetail,
          meta: {
            middleware: auth
          }
        },
        {
          path: '/consultar-transacoes',
          name: 'search-transactions',
          component: SearchTransactions,
          meta: {
            middleware: auth
          }
        }
      ]
    }
  ]
})

function nextFactory (context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  if (!subsequentMiddleware) return context.next

  return (...parameters) => {
    context.next(...parameters)
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware]

    const context = {
      from,
      next,
      router,
      to
    }
    const nextMiddleware = nextFactory(context, middleware, 1)

    return middleware[0]({ ...context, next: nextMiddleware })
  }

  return next()
})

export default router
